import { ButtonList, IconNames } from '@dixa/lib-shared-habla';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import cx from 'classnames';

import s from './popupMenu.module.scss';

type PopupMenuHeaderProps = {
  label: string;
};

export function PopupMenuHeader({ label }: PopupMenuHeaderProps): JSX.Element {
  return (
    <DropdownMenu.Label asChild>
      <ButtonList.Header className={s['popupMenuHeader']}>
        {label}
      </ButtonList.Header>
    </DropdownMenu.Label>
  );
}

export function PopupMenuItemSeparator(): JSX.Element {
  return (
    <DropdownMenu.Separator asChild>
      <ButtonList.Divider />
    </DropdownMenu.Separator>
  );
}

type PopupMenuItemProps = {
  icon?: IconNames;
  className?: string;
  label: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  onSelect: () => void;
};

export const PopupMenuItem = ({
  onSelect,
  icon,
  label,
  className,
  isSelected,
  isDisabled,
}: PopupMenuItemProps): JSX.Element => {
  return (
    <DropdownMenu.Item onSelect={onSelect} className={cx(s['popupMenuItem'])}>
      <ButtonList.Item
        icon={icon}
        isDisabled={isDisabled}
        isSelected={isSelected}
        className={className}
      >
        {label}
      </ButtonList.Item>
    </DropdownMenu.Item>
  );
};
